import { useShop } from '../../../Providers/ShopProvider'
import CategoriesFeature from './CategoriesFeature';
import ProductFilterOnlyAvailable from '../../../Components/HomePage/ProductFilterOnlyAvailable';
import ProductGlobalFilters from '../../../Components/HomePage/Components/ProductGlobalFilters';
import ProductFeature from '../../../Components/HomePage/ProductFeature';
import ProductSuppliersFilter from '../../../Components/HomePage/Components/ProductSuppliersFilter';
import { useParams } from '../../../Providers/ParamsProvider';

const SideBar = () => {
    const { isMobile } = useParams()
    const { productsFeatures, features, setFeatures, showFeatureListFilter, productsFilter } = useShop()

    return (
        <div className='sideBar col-12 col-xl-3' >
            {!isMobile && <CategoriesFeature />}
            <FilterFeaturesTypeSection
                showFeatureListFilter={showFeatureListFilter}
                features={features}
                query={productsFilter.SearchingQuery}
            />
            <ProductFilterOnlyAvailable />
            <ProductSuppliersFilter />
            <ProductGlobalFilters />
            {(showFeatureListFilter) && productsFeatures.map((feature, index) => {
                if (feature.name !== 'Kategorie') {
                    return <ProductFeature
                        key={index}
                        feature={feature}
                        setFeatures={setFeatures}
                        features={features}
                    />
                }
            })}
        </div>
    )
}

const FilterFeaturesTypeSection = ({ showFeatureListFilter, features, query }) => {
    if (!showFeatureListFilter || (features.length === 0 && !query)) {
        return
    }
    return (<>
        <div className='row mt-4 mb-5'>
            <div className='col-12 ms-4  feature-name'>Filtry</div>
            <div className='col-8 ms-4'>
                {query && (
                    <div className="row mt-2">
                        <div className='col choosed-feature-category-name'>
                            {`Szukaj: ${query.charAt(0).toUpperCase() + query.slice(1).toLowerCase()}`}
                        </div>
                    </div>
                )}
                {features.map((feature, key) => (
                    <div key={key} className='row mt-2'>
                        <div className='col choosed-feature-category-name'>
                            {feature.name.charAt(0).toUpperCase() + feature.name.slice(1).toLowerCase()}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </>)
}
export default SideBar